document.addEventListener("turbo:load", function (event) {
  $(window).scroll(function () {
    document
      .querySelectorAll(".trix-content a")
      .forEach(function (element) {
        element.target = "_blank";
      });
  });

  $(".carousel").carousel({
    interval: 5000,
    pause: false,
  });
});
